import i from "./isArray.js";
import o from "./isSymbol.js";
var s = i, n = o, y = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, f = /^\w*$/;
function m(r, e) {
  if (s(r))
    return !1;
  var t = typeof r;
  return t == "number" || t == "symbol" || t == "boolean" || r == null || n(r) ? !0 : f.test(r) || !y.test(r) || e != null && r in Object(e);
}
var b = m;
export {
  b as default
};
//# sourceMappingURL=_isKey.js.map
